/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/jsx-sort-props */
import Spinner from '@atlaskit/spinner';
import React, { FC, useState } from 'react';


export interface AddContactPopupProps{
    onSave: () => void,
    onClose: () => void,
    isOpen: boolean,
    isLoading: boolean
}
const AddContactPopup: FC<AddContactPopupProps> = ({ onSave, onClose, isOpen, isLoading }) => {
    const [ userInfo, setUserInfo ] = useState({ firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '' });

    const [ error, setError ] = useState({

    });

    const handleClose = () => {
        onClose();
    };

    const onChange = (value: any, name: string) => {
        setUserInfo({
            ...userInfo,
            [name]: value
        });

        setError({
            ...error,
            [name]: undefined
        });
    };

    const handleSubmit = () => {

        const newErrors = {};
        const regSpecial = /[`!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?~]/;
        const regSpecialSpace = /[ `!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?~]/;
        const regNumber = /[0-9]/;
        const regText = /[a-z]|[A-Z]/;
        const regEmail = /^([a-zA-Z0-9_\.\+\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

        if (!userInfo.firstName) {
            newErrors.firstName = 'Please enter your first name !';
        } else if (regSpecial.test(userInfo.firstName) || regNumber.test(userInfo.firstName)) {
            newErrors.firstName = 'No numbers or special characters are allowed.';
        } else if (userInfo.firstName.length > 30) {
            newErrors.firstName = 'Maximum length is 30 characters.';
        }

        // if (!userInfo.phoneNumber) {
        //     newErrors.phoneNumber = 'Please enter your phone number !';
        // }
        if (userInfo.phoneNumber) {
            if (regText.test(userInfo.phoneNumber) || regSpecialSpace.test(userInfo.phoneNumber)) {
                newErrors.phoneNumber = 'Please enter a valid phone number';
            }
        }


        if (!userInfo.lastName) {
            newErrors.lastName = 'Please enter your last name !';
        } else if (regSpecial.test(userInfo.lastName) || regNumber.test(userInfo.lastName)) {
            newErrors.lastName = 'No numbers or special characters are allowed.';
        } else if (userInfo.lastName.length > 30) {
            newErrors.lastName = 'Maximum length is 30 characters.';
        }

        // if (!userInfo.email) {
        //     newErrors.email = 'Please enter your email !';
        // } else
        if (userInfo.email) {
            if (!regEmail.test(userInfo.email)) {
                newErrors.email = 'Check the format of the email you entered';
            } else if (userInfo.email.length > 70) {
                newErrors.email = 'Maximum length is 70 characters.';
            }
        }
        if (!(userInfo.email || userInfo.phoneNumber)) {
            newErrors.email = 'Please enter your email !';
            newErrors.phoneNumber = 'Please enter your phone number !';
        }


        setError(newErrors);

        if (Object.keys(newErrors).find(key => newErrors[key])) {
            return;
        }
        onSave({
            ...userInfo,
            phoneNumber: userInfo.phoneNumber.split('-').join('')
        });
    };

    return (
        <div className = 'o-add-contact-popup__wrapper' >
            <div className = 'o-add-contact-popup__background' />
            <div className = 'o-add-contact-popup__container' >
                <div className = { 'o-add-contact-popup' }>
                    <div className = { 'o-add-contact-popup--w-100' }>
                        <div
                            className = { 'o-add-contact-popup--close' }
                            onClick = { onClose }>
                            <img
                                src = '../../../../../images/close-sched.svg'
                                width = { 31 }
                                height = { 31 } />
                        </div>
                    </div>
                    <div className = { 'o-add-contact-popup--title' }>
                        add contact
                    </div>
                    <div className = { 'o-add-contact-popup--inputs' }>
                        <input
                            className = { 'o-add-contact-popup--inputs--input' }
                            type = 'text'
                            value = { userInfo.firstName }
                            onChange = { e => onChange(e.target.value, 'firstName') }
                            placeholder = { 'First name' } />
                        {error.firstName ? <span className = { 'o-add-contact-popup--inputs--label-error' }>{error.firstName}</span> : null}
                        <input
                            className = { 'o-add-contact-popup--inputs--input' }
                            type = 'text'
                            value = { userInfo.lastName }
                            onChange = { e => onChange(e.target.value, 'lastName') }
                            placeholder = { 'Last name' } />
                        {error.lastName ? <span className = { 'o-add-contact-popup--inputs--label-error' }>{error.lastName}</span> : null}
                        <input
                            className = { 'o-add-contact-popup--inputs--input' }
                            type = 'text'
                            value = { userInfo.phoneNumber }
                            onChange = { e => onChange(e.target.value, 'phoneNumber') }
                            placeholder = { 'Phone number' } />
                        {error.phoneNumber ? <span
                            className = { 'o-add-contact-popup--inputs--label-error' }>{error.phoneNumber}</span> : null}
                        <input
                            className = { 'o-add-contact-popup--inputs--input' }
                            value = { userInfo.email }
                            onChange = { e => onChange(e.target.value, 'email') }
                            type = 'text'
                            placeholder = { 'E-mail' } />
                        {error.email ? <span
                            className = { 'o-add-contact-popup--inputs--label-error' }>{error.email}</span> : null}
                    </div>

                    <div className = { 'o-add-contact-popup--buttons' }>
                        <div
                            className = { 'o-add-contact-popup--cancel' }
                            onClick = { handleClose }>
                            cancel
                        </div>
                        <div
                            className = { 'o-add-contact-popup--save' }
                            onClick = { handleSubmit }>
                            {isLoading ? <Spinner /> : 'save'}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

AddContactPopup.defaultProps = {
    onSave: () => {},
    onClose: () => {},
    isOpen: false
};
export default AddContactPopup;
